"use strict";
var Observable_1 = require('../../Observable');
var groupBy_1 = require('../../operator/groupBy');
Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
//# sourceMappingURL=groupBy.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/groupBy.js
// module id = 659
// module chunks = 2